/**
 * TanStack Query client configuration.
 * 
 * Provides caching, background refetching, and error handling
 * for all data fetching operations in the admin dashboard.
 * 
 * @module lib/queryClient
 */

import { QueryClient } from '@tanstack/react-query';

/**
 * Global query client with optimized settings for admin dashboard.
 * 
 * - 5 minute stale time (data considered fresh)
 * - 30 minute garbage collection time
 * - 2 retries on failure (except auth errors)
 * - No refetch on window focus (admin viewing stable data)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        // Don't retry on auth errors
        if (error instanceof Error) {
          const message = error.message.toLowerCase();
          if (
            message.includes('jwt') ||
            message.includes('unauthorized') ||
            message.includes('not authenticated')
          ) {
            return false;
          }
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
